import { useMemo } from 'react';

import { requiredCruisingSpeedForRoi } from '@/domain/engine';
import { extractSimulatorState } from '@/hooks/useServerPersistence';
import { useSimulatorState } from '@/store/useSimulatorState';

/**
 * Retourne le rythme de croisière minimum (nouveaux clients/mois) pour atteindre
 * le break-even global (ROI) dans l'horizon de projection, ou `null` si infaisable.
 */
export function useRequiredAcquisition(): number | null {
  const store = useSimulatorState();
  return useMemo(() => requiredCruisingSpeedForRoi(extractSimulatorState(store)), [store]);
}
